/**
 * Admin hub — tabs: Přehled · Analytika · Simulace · Databáze.
 * Auth-gated (ADMIN_EMAILS backend check via user.is_admin).
 */
import React, { useState } from "react";
import { ChartBar, ChartLineUp, PlayCircle, Database } from "@phosphor-icons/react";
import { useAuth } from "../contexts/AuthContext";
import AdminOverview from "./admin/AdminOverview";
import AdminUsage from "./admin/AdminUsage";
import AdminSimInsights from "./admin/AdminSimInsights";
import AdminDbBrowser from "./admin/AdminDbBrowser";

const TABS = [
    { key: "overview", label: "Přehled", icon: ChartBar, el: AdminOverview },
    { key: "usage", label: "Analytika", icon: ChartLineUp, el: AdminUsage },
    { key: "sims", label: "Simulace", icon: PlayCircle, el: AdminSimInsights },
    { key: "db", label: "Databáze", icon: Database, el: AdminDbBrowser },
];

export default function AdminAnalytics() {
    const { user, loading: authLoading, login } = useAuth();
    const isAdmin = !!user?.is_admin;
    const [tab, setTab] = useState("overview");

    if (authLoading) {
        return <div className="max-w-6xl mx-auto p-8 font-mono text-white/50">Načítám…</div>;
    }

    if (!user) {
        return (
            <div className="max-w-3xl mx-auto p-8 space-y-4">
                <h1 className="font-display font-black text-3xl">Admin</h1>
                <p className="text-white/60">Přihlas se prosím admin účtem.</p>
                <button
                    onClick={login}
                    data-testid="analytics-signin-btn"
                    className="font-mono text-[11px] uppercase tracking-widest bg-fa-yellow text-black px-4 py-2 hover:bg-fa-yellowHover font-bold"
                >
                    Přihlásit se
                </button>
            </div>
        );
    }

    if (!isAdmin) {
        return (
            <div className="max-w-3xl mx-auto p-8 space-y-2">
                <h1 className="font-display font-black text-3xl">Admin</h1>
                <p className="text-red-200">Účet <strong>{user.email}</strong> nemá admin oprávnění.</p>
            </div>
        );
    }

    const Active = TABS.find((t) => t.key === tab)?.el || AdminOverview;

    return (
        <div className="max-w-6xl mx-auto p-4 md:p-8 space-y-6" data-testid="admin-analytics-page">
            <header className="space-y-3">
                <h1 className="font-display font-black text-3xl md:text-4xl">Admin</h1>
                <div className="flex gap-1.5 flex-wrap">
                    {TABS.map((t) => {
                        const Icon = t.icon;
                        return (
                            <button
                                key={t.key}
                                type="button"
                                onClick={() => setTab(t.key)}
                                data-testid={`admin-tab-${t.key}`}
                                className={`font-mono text-[10px] uppercase tracking-widest px-3 py-1.5 flex items-center gap-1.5 border ${tab === t.key ? "bg-fa-yellow text-black border-fa-yellow font-bold" : "border-white/15 text-white/60 hover:text-white"}`}
                            >
                                <Icon size={11} weight={tab === t.key ? "fill" : "regular"} />
                                {t.label}
                            </button>
                        );
                    })}
                </div>
            </header>
            <Active />
        </div>
    );
}
